export interface IToast {
  heading: string;
  content?: any;
  type: ToastType;
  timestamp: number;
  timeout?: number;
}

//Toast types, reflecting Bootstrap Alerts
export enum ToastType {
  Info,
  Success,
  Danger,
  Warning,
}
